export enum CommonProperties {
  EventBusChannel = 'EventBusChannel',
  Source = 'source',
}
